import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  getCourseData(variables = {}) {
    return query(operations.COURSE_DATA, variables, true);
  },
  submitCourseResult(variables = {}) {
    return mutation(operations.COURSE_RESULT, variables, true);
  },
};
